import { TalkhattabatConversationType } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import MessageInputField from "./MessageInput";
import SendMessageButton from "./SendMessageButton";
import UploadImage from "./UploadImage";

const SendMessage = withLiteObserverAndTheme<{
  conversationID: string;
  oneOTwoConversationId: string;
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  peerID: number;
  peerUUID: string;
  conversationType: TalkhattabatConversationType;
  oneOOneCId: string
}>((props) => {
  const {
    theme,
    conversationID,
    oneOTwoConversationId,
    alkhattabaUUID,
    userUUID,
    peerID,
    peerUUID,
    conversationType,
    userID,
    oneOOneCId
  } = props;
  const { colors } = theme;

  return (
    <ET3Div
      width={1188}
      height={68}
      alignItems={"center"}
      fDirection={"row"}
      color={""}
      style={{
        backgroundColor: colors.all.paleGrayishWhite
      }}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <MessageInputField
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        conversationID={conversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        peerID={peerID}
        userID={userID}
        peerUUID={peerUUID}
        conversationType={conversationType}
        oneOOneCId={oneOOneCId}
      />
      <Et3Margin top={0} bottom={0} left={4} right={4} />
      <UploadImage
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        userID={userID}
        conversationID={conversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        peerID={peerID}
        peerUUID={peerUUID}
        conversationType={conversationType}
        oneOOneCId={oneOOneCId}
      />
      <Et3Margin top={0} bottom={0} left={4} right={4} />
      <SendMessageButton
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        userID={userID}
        conversationID={conversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        peerID={peerID}
        peerUUID={peerUUID}
        conversationType={conversationType}
        oneOOneCId={oneOOneCId}
      />
    </ET3Div>
  );
});

export default SendMessage;
